import {
  List,
  Toolbar,
  AutocompleteInput,
  ImageInput,
  NumberInput,
  SelectInput,
  TextInput,
} from "react-admin";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";

export const AddAndOrderButtonStyles = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(1),
}));

export const ListStyles = styled(List)(({ theme }) => ({
  "& .add-filter": {
    height: theme.spacing(2.5),
  },
  "& .RaCreateButton-root": {
    height: theme.spacing(2.5),
  },
}));

export const ToolbarStyles = styled(Toolbar)(() => ({
  justifyContent: "space-between",
}));

export const OrderableListStyles = styled(List)(() => ({
  width: "100%",
}));

export const TextInputField = styled(TextInput)(() => ({
  width: 250,
}));

export const ImageInputField = styled(ImageInput)(() => ({
  width: 250,
}));

export const AutoCompleteInputField = styled(AutocompleteInput)(() => ({
  width: 250,
}));

export const SelectInputField = styled(SelectInput)(() => ({
  width: 250,
}));

export const NumberInputField = styled(NumberInput)(() => ({
  width: 250,
}));
